import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Lazy load page components for better performance
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Services = lazy(() => import('./pages/Services'));
const ServiceDetail = lazy(() => import('./pages/ServiceDetail'));
const ERPSolutions = lazy(() => import('./pages/services/ERPSolutions'));
const WebDevelopment = lazy(() => import('./pages/services/WebDevelopment'));
const AIIntegration = lazy(() => import('./pages/services/AIIntegration'));
const AppDevelopment = lazy(() => import('./pages/services/AppDevelopment'));
const SaaSOnPremises = lazy(() => import('./pages/services/SaaSOnPremises'));
const CloudDevOps = lazy(() => import('./pages/services/CloudDevOps'));
const SmartDevices = lazy(() => import('./pages/services/SmartDevices'));
const Industries = lazy(() => import('./pages/Industries'));
const IndustryDetail = lazy(() => import('./pages/IndustryDetail'));
const Healthcare = lazy(() => import('./pages/industries/Healthcare'));
const Finance = lazy(() => import('./pages/industries/Finance'));
const Retail = lazy(() => import('./pages/industries/Retail'));
const Manufacturing = lazy(() => import('./pages/industries/Manufacturing'));
const Education = lazy(() => import('./pages/industries/Education'));
const Telecommunications = lazy(() => import('./pages/industries/Telecommunications'));
const Logistics = lazy(() => import('./pages/industries/Logistics'));
const RealEstate = lazy(() => import('./pages/industries/RealEstate'));
const ISP = lazy(() => import('./pages/industries/ISP'));
const MLM = lazy(() => import('./pages/industries/MLM'));
const RMGTextile = lazy(() => import('./pages/industries/RMGTextile'));
const NGO = lazy(() => import('./pages/industries/NGO'));
const Team = lazy(() => import('./pages/Team'));
const Contact = lazy(() => import('./pages/Contact'));
const ChooseApp = lazy(() => import('./pages/ChooseApp'));
const Universe = lazy(() => import('./pages/Universe'));

// Loading fallback component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
  </div>
);

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Universe />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/erp-solutions" element={<ERPSolutions />} />
            <Route path="/services/web-development" element={<WebDevelopment />} />
            <Route path="/services/ai-integration" element={<AIIntegration />} />
            <Route path="/services/app-development" element={<AppDevelopment />} />
            <Route path="/services/saas-on-premises" element={<SaaSOnPremises />} />
            <Route path="/services/cloud-devops" element={<CloudDevOps />} />
            <Route path="/services/smart-devices" element={<SmartDevices />} />
            <Route path="/services/:serviceId" element={<ServiceDetail />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/industries/healthcare" element={<Healthcare />} />
            <Route path="/industries/finance" element={<Finance />} />
            <Route path="/industries/retail" element={<Retail />} />
            <Route path="/industries/manufacturing" element={<Manufacturing />} />
            <Route path="/industries/education" element={<Education />} />
            <Route path="/industries/telecommunications" element={<Telecommunications />} />
            <Route path="/industries/logistics" element={<Logistics />} />
            <Route path="/industries/real-estate" element={<RealEstate />} />
            <Route path="/industries/isp" element={<ISP />} />
            <Route path="/industries/mlm" element={<MLM />} />
            <Route path="/industries/rmg-textile" element={<RMGTextile />} />
            <Route path="/industries/ngo" element={<NGO />} />
            <Route path="/industries/:industryId" element={<IndustryDetail />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/choose-your-app" element={<ChooseApp />} />
            {/* Catch-all route to redirect unknown paths to Home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
};

export default App;
